import React from "react";
import DarkModeToggle from "react-dark-mode-toggle";

function DarkMode() {
  const [checked, setChecked] = React.useState(
    localStorage.getItem("checked") === "true"
  );

  const body = document.body;
  const lightTheme = "null";
  const darkTheme = "light-theme";
  let theme;

  if (localStorage) {
    theme = localStorage.getItem("theme");
  }

  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme);
  } else {
    body.classList.add(lightTheme);
  }

  const switchTheme = (e) => {
    if (theme === darkTheme) {
      setChecked(false);
      localStorage.setItem("checked", "false");
      body.classList.replace(darkTheme, lightTheme);
      localStorage.setItem("theme", "null");
      theme = lightTheme;
    } else {
      setChecked(true);
      localStorage.setItem("checked", "true");
      body.classList.replace(lightTheme, darkTheme);
      localStorage.setItem("theme", "light-theme");
      theme = darkTheme;
    }
  };

  return (
    <DarkModeToggle
      onChange={(e) => switchTheme(e)}
      checked={checked}
      size={50}
    />
  );
}

export default DarkMode;
